import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import type { CarouselBatch } from "../state/formReducer"
import { useObjectUrlSrc } from "./useObjectUrlSrc"

/**
 * Carousel preview modal — opens from a chip click in the preview
 * list. Parity: `creatives.js:275-329`.
 */

interface Props {
  batch: CarouselBatch | null
  onClose: () => void
}

function PreviewImage({ file, index }: { file: File; index: number }) {
  const srcRef = useObjectUrlSrc(file)
  return (
    <div className="relative">
      <img
        ref={srcRef}
        alt={file.name}
        className="block h-40 w-full rounded object-cover"
      />
      <span className="absolute left-1 top-1 rounded bg-black/70 px-2 py-0.5 text-xs">
        #{index + 1}
      </span>
    </div>
  )
}

function MusicPlayer({ file }: { file: File }) {
  const srcRef = useObjectUrlSrc(file)
  return (
    <div className="mt-3">
      <div className="text-xs text-white">Music: {file.name}</div>
      <audio controls ref={srcRef} className="mt-1 w-full" />
    </div>
  )
}

export function CarouselPreviewModal({ batch, onClose }: Props) {
  return (
    <Dialog open={batch !== null} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="max-w-3xl">
        <DialogHeader>
          <DialogTitle>Carousel {batch?.index ?? ""}</DialogTitle>
        </DialogHeader>
        {batch ? (
          <div>
            <div className="grid grid-cols-2 gap-2 md:grid-cols-3">
              {batch.images.map((file, i) => (
                <PreviewImage
                  key={`${file.name}-${i}-${file.size}`}
                  file={file}
                  index={i}
                />
              ))}
            </div>
            {batch.music ? <MusicPlayer file={batch.music} /> : null}
          </div>
        ) : null}
      </DialogContent>
    </Dialog>
  )
}
